(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-intro"] && !Shopify.designMode) return;
  try {
    
(function(){
  var intro = document.getElementById('vt-intro');
  if(!intro) return;

  var frequency = intro.dataset.frequency || 'session';
  var storageKey = 'vt_intro_seen';
  var storage = frequency === 'once' ? window.localStorage : window.sessionStorage;
  if(storage.getItem(storageKey)){
    intro.remove();
    document.dispatchEvent(new CustomEvent('vt:introComplete'));
    return;
  }

  function closeIntro(){
    storage.setItem(storageKey, '1');
    intro.classList.add('is-leaving');
    setTimeout(function(){
      if(intro.parentNode) intro.remove();
      document.dispatchEvent(new CustomEvent('vt:introComplete'));
    }, 800);
  }
  document.getElementById('vt-intro-skip').addEventListener('click', closeIntro);
  var enterBtn = document.getElementById('vt-intro-enter');
  if(enterBtn) enterBtn.addEventListener('click', closeIntro);

  var soundBtn = document.getElementById('vt-intro-sound');
  var audioEl = document.getElementById('vt-intro-audio');
  if(soundBtn && audioEl){
    var playing = false;
    soundBtn.addEventListener('click', function(){
      playing = !playing;
      soundBtn.setAttribute('aria-pressed', String(playing));
      soundBtn.querySelector('.vt-intro__sound-icon').textContent = playing ? '\uD83D\uDD0A' : '\uD83D\uDD07';
      if(playing){ audioEl.play().catch(function(){ playing = false; }); } else { audioEl.pause(); }
    });
  }

  setTimeout(function(){ if(document.body.contains(intro)) closeIntro(); }, 6500);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeIntro(); });

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reducedMotion){
    var field = document.getElementById('vt-intro-particles');
    if(field){
      for(var i=0;i<24;i++){
        var p = document.createElement('span');
        p.className = 'vt-intro__particle';
        p.style.left = (Math.random()*100) + '%';
        p.style.top = (60 + Math.random()*30) + '%';
        p.style.animationDelay = (Math.random()*3) + 's';
        p.style.animationDuration = (3 + Math.random()*2.5) + 's';
        field.appendChild(p);
      }
    }
  }

  var cssStage = document.getElementById('vt-intro-css-stage');
  function isDesktopCapable(){
    var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var wideEnough = window.innerWidth >= 900;
    var hasWebGL = false;
    try { var c = document.createElement('canvas'); hasWebGL = !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch(e){}
    return pointerFine && wideEnough && hasWebGL;
  }
  function showCssFallback(){ cssStage.hidden = false; }
  function tryGlb(){
    if(!(intro.dataset.glbUrl && isDesktopCapable())){ showCssFallback(); return; }
    var mount = document.getElementById('vt-intro-3d-mount');
    var script = document.createElement('script'); script.type = 'module';
    script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    script.onload = function(){
      mount.hidden = false; cssStage.hidden = true;
      mount.innerHTML = '<model-viewer src="' + intro.dataset.glbUrl + '" auto-rotate camera-controls autoplay style="width:100%;height:100%;"></model-viewer>';
      mount.querySelector('model-viewer').addEventListener('error', function(){ mount.hidden = true; showCssFallback(); });
    };
    script.onerror = function(){ showCssFallback(); };
    document.head.appendChild(script);
  }
  function tryMp4(){
    var isMobile = window.innerWidth < 750;
    var src = isMobile ? intro.dataset.mobileVideo : intro.dataset.desktopVideo;
    if(!src){ tryGlb(); return; }
    var videoEl = document.getElementById('vt-intro-video');
    videoEl.src = src;
    videoEl.addEventListener('error', function(){ videoEl.hidden = true; tryGlb(); }, { once: true });
    videoEl.addEventListener('canplay', function(){ cssStage.hidden = true; videoEl.hidden = false; videoEl.play().catch(function(){ videoEl.hidden = true; tryGlb(); }); }, { once: true });
    setTimeout(function(){ if(videoEl.readyState < 3){ videoEl.hidden = true; tryGlb(); } }, 2500);
  }
  function tryWebm(){
    if(!intro.dataset.webmUrl){ tryMp4(); return; }
    var testEl = document.createElement('video');
    var supportsAlphaWebm = testEl.canPlayType && testEl.canPlayType('video/webm; codecs="vp9"') !== '';
    if(!supportsAlphaWebm){ tryMp4(); return; }
    var webmEl = document.getElementById('vt-intro-webm');
    webmEl.src = intro.dataset.webmUrl;
    webmEl.addEventListener('error', function(){ webmEl.hidden = true; tryMp4(); }, { once: true });
    webmEl.addEventListener('canplay', function(){ cssStage.hidden = true; webmEl.hidden = false; webmEl.play().catch(function(){ webmEl.hidden = true; tryMp4(); }); }, { once: true });
    setTimeout(function(){ if(webmEl.readyState < 3){ webmEl.hidden = true; tryMp4(); } }, 2500);
  }
  function tryLottie(){
    if(!intro.dataset.lottieUrl){ tryWebm(); return; }
    var mount = document.getElementById('vt-intro-lottie-mount');
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/lottie-web/build/player/lottie.min.js';
    script.onload = function(){
      try {
        mount.hidden = false; cssStage.hidden = true;
        var anim = window.lottie.loadAnimation({ container: mount, renderer: 'svg', loop: false, autoplay: true, path: intro.dataset.lottieUrl });
        anim.addEventListener('data_failed', function(){ mount.hidden = true; tryWebm(); });
      } catch(e){ mount.hidden = true; tryWebm(); }
    };
    script.onerror = function(){ tryWebm(); };
    document.head.appendChild(script);
  }

  if(reducedMotion){ showCssFallback(); } else { tryLottie(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
